"use client";

import React from "react";
import "./BenefitsSection.css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const distanceBenefits = [
  {
    title: "Personalized Learning Experience: ",
    text: "Study at your own pace with a learning approach tailored to your needs.",
  },
  {
    title: "Rich Digital Resources: ",
    text: "Gain unlimited access to e-books, online libraries, recorded sessions, and study materials.",
  },
  {
    title: "Comfort & Convenience: ",
    text: "Learn from wherever you feel most comfortable without compromising on quality education.",
  },
];

const onlineBenefits = [
  {
    title: "Study Anytime, Anywhere:",
    text: "Learn on your schedule without disrupting your professional or personal life.",
  },
  {
    title: "Seamless Accessibility:",
    text: "Access your classes, assignments, and learning resources from any device with an internet connection.",
  },
  {
    title: "Career-Focused Learning Options:",
    text: "Choose from industry-relevant programs designed to help you achieve your academic and career goals.",
  },
];

const BenefitItem = ({ title, text }) => (
  <div className="benefit_item">
    <div className="benefit_icon">
      <img src="/assets/images/home/Advantage_1-1-1.png" alt="icon" />
    </div>

    <div className="benefit_content">
      <h4>{title}</h4>
      <p>{text}</p>
    </div>
  </div>
);

const BenefitsSection = () => {
  return (
    <section className="benefits_section">
      <div className="container">
        <div className="benefits_grid">
          <div className="benefit_column">
            {/* <h2>Benefits Of Distance Education</h2> */}
            <Main_heading_holder
              heading="Benefits Of "
              spanHeading="Distance Education"
              //   subHeading="Built for people who refuse to pause their careers"
              headingType="h2"
            />

            {distanceBenefits.map((item, index) => (
              <BenefitItem key={index} {...item} />
            ))}
          </div>

          <div className="benefit_column">
            {/* <h2>Benefits Of Online Education</h2> */}
            <Main_heading_holder
              heading="Benefits Of "
              spanHeading="Online Education"
              //   subHeading="Built for people who refuse to pause their careers"
              headingType="h2"
            />

            {onlineBenefits.map((item, index) => (
              <BenefitItem key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
